import React, { useEffect, useContext, useState, useRef,useCallback } from 'react';
import config from "config/config";
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab, Box, Tooltip, TextField, Switch, FormControlLabel } from '@mui/material';
import Context from "context/context";
import ReusableTable from "components/table/table";
import Button from '@mui/material/Button';
import Grid from "@mui/material/Grid";
import "./ManagerView.css";
import check from "../../../../assets/images/check.png";
import cross from "../../../../assets/images/remove.png";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import Modal from '@mui/material/Modal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { styled } from "@mui/material/styles";
import { tooltipClasses } from "@mui/material/Tooltip";
import { Card, CardContent, Typography,CardMedia,IconButton } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { Checkbox } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Addtemplate from "../../../../assets/images/AddTemplate.png";
import savedtemplate from "../../../../assets/images/savedtemplate.jpg";
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import EditTemplate from './EditTemplate';
import AddGoals from './AddGoals';
import ReviewAssesment from './ReviewAssesment'

// import AppraisalCycle from './AppraisalCycle';

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
    cursor: "pointer",
    backgroundColor: "#002c5d",
    color: "#ffffff",
  },
});

const ManagerView = () => {
    const [value, setValue] = useState("1");
  const [showContent, setShowContent] = useState(false);
  const { state, dispatch } = useContext(Context);
  const [kpiData, setKpiData] = useState([]);
  const [kpiKraData, setKpiKraData] = useState([]);
  const [count, setCount] = useState(0);
  const [offset, setOffset] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [selectedKpiIds, setSelectedKpiIds] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [templateName, setTemplateName] = useState("");
  const [assessmentTemplateId, setAssessmentTemplateId] = useState("");
  const [templates, setTemplates] = useState([]);
  const navigate = useNavigate();
  const [templateData, setTemplateData] = useState(null); 
  const [isTemplateOpen, setIsTemplateOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [originalKpiIds, setOriginalKpiIds] = useState([]);
  


  const limit = 10;

 
  const handleEditTemplate = () => {
    setIsEditing(true); // Enter editing mode
    setIsTemplateOpen(false); // Close other content
  };
  
    const fetchTemplates = async (search = "") => {
        const query = encodeURIComponent(
            JSON.stringify({
              offset: (offset - 1) * limit,
              limit: limit,
              searchValue: search,
            })
          );
      try {
        const response = await fetch(`${config.host}/panel/pms/allTemplates?query=${query}`, {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });
        const data = await response.json();
        if (data.status === "Ok") {
          setTemplates(data.data.templatesData);
        } else {
          console.error("Failed to fetch templates");
        }
      } catch (error) {
        console.error("Error fetching templates:", error);
      }
    };

    useEffect(() => {

    fetchTemplates();
  }, []);

  // Navigate to template detail page
  const handleTemplateClick = async (template) => {
    dispatch({ type: "SET_LOADING", payload: true });
    try {
      // Fetch the template details using fetch API
      const url = `${config.host}/panel/pms/updateTemplates?assessmentTemplateId=${template.assessmentTemplateId}`;
      const response = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      // Check if the response is ok
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Error fetching template: ${errorData.message || 'Unknown error'}`);
        dispatch({ type: "SET_LOADING", payload: false });
      }
  
      // Parse the response data
      const data = await response.json();
      if (data.status === "Ok") {
        const fetchedTemplate = data.data.templateData[0];
        setTemplateData(fetchedTemplate);
        setIsTemplateOpen(true);
        setAssessmentTemplateId(fetchedTemplate.assessmentTemplateId);
        dispatch({ type: "SET_LOADING", payload: false });

        if (fetchedTemplate.kpiKraDetails) {
            const kpiIds = fetchedTemplate.kpiKraDetails.map((kpi) => kpi.kpiKraDetailsId);
            setSelectedKpiIds(kpiIds);
            setOriginalKpiIds(kpiIds);
          }
  
        // After fetching the template data, fetch the related KPIs
        fetchKpiData(); // You can pass search terms here if needed
  
        
        
      } else {
        console.error("Failed to fetch template");
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (error) {
      console.error("Error fetching template details:", error);
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };
  



  const fetchKpiData = useCallback(async (search = "") => {
    try {
      const query = encodeURIComponent(
        JSON.stringify({
          offset: (offset - 1) * limit,
          limit: limit,
          searchValue: search,
        })
      );
      dispatch({ type: "SET_LOADING", payload: true });
      const url = `${config.host}/panel/pms/allActiveKpi?query=${query}`;

      const response = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error response data:", errorData);
        throw new Error(`HTTP error! status: ${response.status}, ${errorData.message || ""}`);
      }

      const data = await response.json();

      if (data.status === "Ok" && Array.isArray(data.data.kpiKraData)) {
        const formattedData = data.data.kpiKraData.map((kpi, index) => [
          index + 1 + (offset - 1) * limit,
          kpi.kraCategory,
          kpi.kpiName,
          kpi.weightage ?? "N/A",
          kpi.role,
        //   kpi.isActive ? (
        //     <img style={{ height: "20px" }} src={check} alt="Active" />
        //   ) : (
        //     <img style={{ height: "20px" }} src={cross} alt="Inactive" />
        //   ),
          <Tooltip title="Select KPI">
            <Checkbox
              checked={selectedKpiIds.includes(kpi.kpiKraId)}
              onChange={() => handleCheckboxChange(kpi.kpiKraId)}
              color="primary"
            />
          </Tooltip>,
        ]);
        setKpiData(formattedData);
        setCount(data.data.count);
        dispatch({ type: "SET_LOADING", payload: false });
      } else {
        console.error("Unexpected data format:", data);
        setKpiData([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
    }
  }, [selectedKpiIds, offset, searchValue]); // add dependencies here

  useEffect(() => {
    fetchKpiData(searchValue);
  }, [fetchKpiData, selectedKpiIds]); // add selectedKpiIds to dependencies

  const handleCheckboxChange = useCallback((kpiId) => {
    setSelectedKpiIds((prevSelectedIds) => {
      const updatedSelectedIds = prevSelectedIds.includes(kpiId)
        ? prevSelectedIds.filter((id) => id !== kpiId)
        : [...prevSelectedIds, kpiId];
      console.log("Updated selected KPI IDs:", updatedSelectedIds); // Debugging log
      return updatedSelectedIds;
    });
  }, []);

  const renderCheckboxColumn = (kpiId) => (
    <Checkbox
      checked={selectedKpiIds.includes(kpiId)} // Check based on selectedKpiIds
      onChange={() => handleCheckboxChange(kpiId)}
    />
  );

  // Format data for the ReusableTable
  const formattedKpiData = (Array.isArray(kpiData) ? kpiData : []).map((kpi, index) => ({
    ...kpi,
    checkbox: renderCheckboxColumn(kpi.id), // Add checkbox column
  }));

  const handleChange = (event, newValue) => {
    setValue(newValue);

    setShowContent(false);
    setKpiData([]);
    setTemplates([]);
    setTemplateData(null);
    setSelectedKpiIds([]);
    setIsTemplateOpen(false);
    setIsEditing(false);
  };

  useEffect(() => {
    if (value === "1") {
      fetchTemplates();
    } else if (value === "2") {
      fetchKpiData();
    }
  }, [value]);

  const handleAddTemplateClick = () => {
    setShowContent(true);
  };

  const handleBackToCard = () => {
    setShowContent(false);
    setTemplateData(null);
    setSelectedKpiIds([]);
    setOffset(1);
  };
  const handleBackFromView = () => {
    setIsTemplateOpen(false); // Close template details view
  setTemplateData(null); // Clear the template data
  setSelectedKpiIds([]);
  };

  const handleBackFromEdit = () => {
    setIsEditing(false); // Exit editing mode
    setSelectedKpiIds([]);
  };


  

  const handleCreateTemplate = () => {
    if (selectedKpiIds.length === 0) {
        toast.error("Please select at least one KPI before saving the template.");
        return;
    }
    setIsModalOpen(true); // Open the modal
  };

  const handleSaveChangesTemplate = async () => {
    if (JSON.stringify(selectedKpiIds.sort()) === JSON.stringify(originalKpiIds.sort())) {
        toast.info("No changes have been made.");
        return; // Exit if no changes are detected
      }
    dispatch({ type: "SET_LOADING", payload: true });
    try {
      const response = await fetch(`${config.host}/panel/pms/updateTemplates`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
            assessmentTemplateId,
            kpiKraIds: selectedKpiIds,
        }),
      });
  
      const data = await response.json();
      if (response.ok && data.status === "Ok") {
        toast.success(data.data.msg || "Template edited successfully");
       
        setShowContent(false);
        setTemplateName("");
        fetchTemplates();
        setSelectedKpiIds([]);
        setIsEditing(false);
        dispatch({ type: "SET_LOADING", payload: false });
      } else {
        throw new Error(data.message || "Failed to edit template");
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (error) {
      console.error("Error creating template:", error);
      toast.error("Failed to create template");
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const handleSaveTemplate = async () => {
    dispatch({ type: "SET_LOADING", payload: true });
    try {
      const response = await fetch(`${config.host}/panel/pms/createTemplate`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
            templateName,
            kpiKraIds: selectedKpiIds,
        }),
      });
  
      const data = await response.json();
      if (response.ok && data.status === "Ok") {
        toast.success(data.data.msg || "Template created successfully");
        setIsModalOpen(false);
        setShowContent(false);
        setTemplateName("");
        fetchTemplates();
        setSelectedKpiIds([]);
        dispatch({ type: "SET_LOADING", payload: false });
      } else {
        throw new Error(data.message );
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (error) {
      console.error("Error creating template:", error);
      toast.error(error.message || "Failed to create template");
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const handleCancelTemplate = () => {
    setIsModalOpen(false);
    setTemplateName("");
  };


  const handleDeleteTemplate = async (templateId) => {
    dispatch({ type: "SET_LOADING", payload: true });
    try {
      const response = await fetch(`${config.host}/panel/pms/deleteTemplate?assessmentTemplateId=${templateId}`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
        dispatch({ type: "SET_LOADING", payload: false });
      }
  
      const result = await response.json();
  
      if (result.status === "Ok" && result.data.deleted === 1) {
        // Remove the deleted template from the templates array
        setTemplates((prevTemplates) =>
          prevTemplates.filter((template) => template.assessmentTemplateId !== templateId)
        
        );
        dispatch({ type: "SET_LOADING", payload: false });
        toast.success("Template deleted successfully");
      } else {
        console.error("Failed to delete template:", result);
        dispatch({ type: "SET_LOADING", payload: false });
        toast.error("Failed to delete template");
      }
    } catch (error) {
      console.error("Error deleting template:", error);
      dispatch({ type: "SET_LOADING", payload: false });
      toast.error("Failed to delete template");
    }
  };

  const formattedTemplateData = (templateData?.kpiKraDetails || []).map((kpi, index) => [
    index + 1, // S.No
    kpi.kraCategory || "N/A", // Assuming kraCategory could be a field in each KPI
    kpi.kpiName,
    kpi.weightage ?? "N/A",
    kpi.role ?? "N/A",
    // kpi.isActive ? (
    //   <img style={{ height: "20px" }} src={check} alt="Active" />
    // ) : (
    //   <img style={{ height: "20px" }} src={cross} alt="Inactive" />
    // ),
    // <Tooltip title="Select KPI">
    //   <Checkbox
    //     checked={selectedKpiIds.includes(kpi.kpiKraDetailsId)}
    //     onChange={() => handleCheckboxChange(kpi.kpiKraDetailsId)}
    //     color="primary"
    //   />
    // </Tooltip>,
  ]);



  








  return (
    <div style={{ backgroundColor: "white", borderRadius: "10px" }}>
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleChange} aria-label="HR View Tabs">
              <Tab label="Role Based Goal Templates" value="1" className={value === '1' ? 'Leave' : 'nonleaveTab'} />
              <Tab label="Assign Goals" value="2" className={value === '2' ? 'Leave' : 'nonleaveTab'} />
              <Tab label="REVIEW EMPLOYEE ASSESSMENT" value="3" className={value === '3' ? 'Leave' : 'nonleaveTab'} />
            </TabList>
          </Box>
          <TabPanel value="1">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

<div style={{ display: 'flex', justifyContent: 'center', minHeight: '70vh' }}>
  <div style={{ width: '100%', overflowX: 'auto' }}>
    {/* Display template details if templateData exists */}

    




{isEditing ? (
        // Editing Content
        <div>
          
          <Button className="BackBtn" onClick={handleBackFromEdit}>Back</Button>
          <div>
          <ReusableTable
                title={<div className="leavemanageHeading">KRA/KPI LIST</div>}
                create={
                  <Button className="AddKrabutton" onClick={handleSaveChangesTemplate}>
                    Save Changes
                  </Button>
                }
                searchBar
                data={Array.isArray(kpiData) ? kpiData : []}
                count={count}
                offset={offset}
                setOffset={setOffset}
                limit={limit}
                setSearchValue={(value) => setSearchValue(value ? value.trim() : '')}
                heading={["S.No", "KRA", "KPI Name", "Weightage", "Role", "Action"]}
                placeholder="Search KRA..."
              />
          
        </div>
        </div>
      ) : isTemplateOpen ? (
        <div>
         <Button className="BackBtn" onClick={handleBackFromView}>Back</Button>
      <div style={{ padding: '20px', textAlign: 'center' }}>
       
        <ReusableTable
          title={<div className="leavemanageHeading">KRA/KPI LIST</div>}
          create={
            <Button className="AddKrabutton" onClick={handleEditTemplate}>
              Edit Template
            </Button>
          }
          data={formattedTemplateData}
          // count={formattedTemplateData.length}
          heading={["S.No", "KRA", "KPI Name", "Weightage", "Role"]}
        //   placeholder="Search KPI..."
          setSearchValue={setSearchValue}
          offset={offset}
          setOffset={setOffset}
          limit={limit}
        //   searchBar
        />
      </div>
      </div>
    ) : (
      // Only show the content if templateData is not available
      <div>
        {showContent ? (
          <div style={{ padding: '10px', textAlign: 'left' }}>
            {/* Display alternative content after clicking the card */}
            <Button className="BackBtn" onClick={handleBackToCard}>Back</Button>
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <ReusableTable
                title={<div className="leavemanageHeading">KRA/KPI LIST</div>}
                create={
                  <Button className="AddKrabutton" onClick={handleCreateTemplate}>
                    Create Template
                  </Button>
                }
                searchBar
                data={Array.isArray(kpiData) ? kpiData : []}
                count={count}
                offset={offset}
                setOffset={setOffset}
                limit={limit}
                setSearchValue={(value) => setSearchValue(value ? value.trim() : '')}
                heading={["S.No", "KRA", "KPI Name", "Weightage", "Role", "Action"]}
                placeholder="Search KRA..."
              />
            </div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>

            {templates.map((template) => (
               <Card
               className="card-style"
               key={template.assessmentTemplateId}
               style={{
                 width: '200px',
                 margin: '20px',
                 padding: '20px',
                 textAlign: 'center',
                 cursor: 'pointer',
                 height: '250px',
                 position: 'relative',
                 boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                 borderRadius:"10px",
                 
               }}
               onClick={() => handleTemplateClick(template)}
             >
                      <IconButton
        aria-label="delete"
        onClick={(e) => {
          e.stopPropagation(); // Prevents the click event from propagating to the card's onClick
          handleDeleteTemplate(template.assessmentTemplateId);
        }}
        className="icon-button"
      >
        <DeleteIcon />
      </IconButton>

                <CardMedia
                  component="img"
                  height="200"
                  image={savedtemplate}
                  alt="Saved Template"
                />
                <CardContent>
                  <Typography variant="h6" className="template-name">
                    {template.templateName}
                  </Typography>
                </CardContent>
              </Card>
            ))}

            {/* Add new template card */}
            <Card
            className="card-style"
              style={{
                width: '200px',
                margin: '20px',
                padding: '20px',
                textAlign: 'center',
                cursor: 'pointer',
                height: '250px',
                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
                borderRadius:"10px",
              }}
              onClick={handleAddTemplateClick}
            >
              <CardMedia
                component="img"
                height="200"
                image={Addtemplate}
                alt="Add New Template"
              />
              <CardContent>
                <Typography variant="body1" className="template-name">
                  Add new template
                </Typography>
              </CardContent>
            </Card>
          </div>
        )}
      </div>
    )}
  </div>
</div>
    </TabPanel>
          <TabPanel value="2">
            <AddGoals />
          </TabPanel>
          <TabPanel value="3">
          <ReviewAssesment />
          </TabPanel>
        </TabContext>
      </Box>
      <Modal open={isModalOpen} onClose={handleCancelTemplate}>
        <Box className="custom-modal-box-template" sx={{ padding: 4, backgroundColor: "white", borderRadius: "8px", maxWidth: 400, margin: "auto", marginTop: "10%" }}>
          <Typography className="modal-title-template" variant="h6" gutterBottom>Create New Template</Typography>
          <TextField
            fullWidth
            label="Template Name"
            value={templateName}
            onChange={(e) => setTemplateName(e.target.value)}
            margin="normal"
            className="modal-input-template"
          />
          <Box className="modal-actions-template" display="flex" justifyContent="flex-end" gap={2} mt={2}>
            <Button  className="save-button-template" variant="contained" color="primary" onClick={handleSaveTemplate}>Save</Button>
            <Button className="cancel-button-template" variant="outlined" onClick={handleCancelTemplate}>Cancel</Button>
          </Box>
        </Box>
      </Modal>


    </div>
  );
};

export default ManagerView;